











import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { MCQueryList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { MessageBox } from 'element-ui'
import EditMedicineCabineDialog from './EditMedicineCabineDialog.vue'
import ChangeStatusMedicineCabineDialog from './ChangeStatusMedicineCabineDialog.vue'
import constant from '@/utils/constant'
import { MedicineCabinetStatusFormat } from '@/utils/tyepconvert'
import MCBindUserDialog from './MCBindUserDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    EditMedicineCabineDialog,
    ChangeStatusMedicineCabineDialog,
    MCBindUserDialog
  },
})
export default class MedicineCabinetList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [
    { title: '药柜名称', param: 'name' },
    { title: '药柜状态', param: 'status', type: 'select', selectData: constant.MedicineCabinetStatus},
    { title: '投资人手机号', param: 'mobilePhone' },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
    { title: '新增药柜', type: 'primary', click: this.openCreateVideo },
  ]
  // 数据表头 - 
  // 视频比例 ()
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '药柜名称', param: 'name' },
    { title: '设备号', param: 'deviceId' },
    { title: '供应商', param: 'supplierName' },
    // { title: '投资人手机号', param: 'mobilePhone' },
    // { title: '投资人昵称', param: 'nickname' },
    { title: '位置', param: 'address' },
    { title: '状态', param: 'status' , formatter: MedicineCabinetStatusFormat},
    { title: '创建时间', param: 'createTime', formatter: DateFormat },
    {
      title: '操作',
      operation: [
        { title: '编辑', click: this.openEditVideo },
        { title: '修改状态', click: this.openChangeStatus },
        { title: '绑定投资人', click: this.openBindUser },
      ],
    },
  ]

  public async created() {
    this.loadData()
  }
  private openCreateVideo(){
    const d = this.$refs.EditMedicineCabineDialog as EditMedicineCabineDialog
    d.open({}, false)
  }

  private openChangeStatus(data: any){
    const d = this.$refs.ChangeStatusMedicineCabineDialog as ChangeStatusMedicineCabineDialog
    d.open(data)
  }
  
  private openBindUser(data: any){
    const d = this.$refs.MCBindUserDialog as MCBindUserDialog
    d.open(data)
  }

  private delete(data: any) {
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      // const ruslt = await VideoDelte({ id: data.id })
      // if (ruslt) {
      //   Message.success('删除成功')
      //   this.loadData()
      // }
    })
  }

  public openEditVideo(data: any){
    const d = this.$refs.EditMedicineCabineDialog as EditMedicineCabineDialog
    d.open(data, true)
  }

  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await MCQueryList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
  
}
